RivalIQ.apps.Insights.module('widgets.media', function (media, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const MAX_POSTS_PER_ROW = 4;

    function sortGridItem(sortOrder, orderByProperty, sortFcn) {
        return function (a, b) {
            let value = sortFcn(a[orderByProperty], b[orderByProperty], sortOrder);

            if (value === 0) {
                value = RivalIQ.utils.sort.default(new Date(a.published_at).valueOf(), new Date(b.published_at).valueOf(), sortOrder);
            }

            if (value === 0) {
                value = RivalIQ.utils.sort.default(a.id, b.id, sortOrder);
            }

            return value;
        };
    }

    RivalIQ.views.PostTagHelpersMixin = {
        getPostTagCountsMetricDef: getPostTagCountsMetricDef,
        getNumPostsCountsMetricDef: getNumPostsCountsMetricDef
    };

    function getPostTagCountsMetricDef(props, concept, objectType) {
        const postTagIdsDef = new RivalIQ.models.MetricDefinition({
            concept: concept,
            dimensions: ['post_tag_id'],
            property: 'count',
            objectType: objectType,
            limit: -1
        });
        RivalIQ.apps.SocialPosts.utils.updateMetric(postTagIdsDef, props);

        return postTagIdsDef;
    }

    function getNumPostsCountsMetricDef(props, concept) {
        const numPostsDef = new RivalIQ.models.MetricDefinition({
            concept: concept,
            dimensions: [],
            property: 'count'
        });
        RivalIQ.apps.SocialPosts.utils.updateMetric(numPostsDef, props);

        return numPostsDef;
    }

    media.InsightsGrid = RivalIQ.views.SocialPostGrid.mixin({

        mixins: {
            mediaLoadErrorHandler: media.MediaLoadErrorHandler,
            PostTagHelpersMixin: RivalIQ.views.PostTagHelpersMixin
        },

        className: function () {
            const me = this;

            let classes = 'row social-post-grid instagram-stories-grid';
            // NOTE: this class will hide the fourth post when the screen is small
            // only add to post widgets with a single row of posts
            if (me.getProp('limit') === MAX_POSTS_PER_ROW) {
                classes += ' social-post-grid-summary';
            }

            return classes;
        },

        getChildView: function () {
            const me = this;

            switch (me.getProp('objectType')) {
                case RivalIQ.enums.insightsObjectType.story:
                    return App.widgets.media.InstagramStoriesGridItem;

                case RivalIQ.enums.insightsObjectType.storyDay:
                    return App.widgets.media.InstagramStoryDaysGridItem;

                case RivalIQ.enums.insightsObjectType.post:
                    return App.widgets.media.InsightsPostGridItem;
                default:
                    throw new Error(`unknown insight objectType ${me.getProp('objectType')}`);
            }
        },

        childViewOptions: function () {
            const me = this;
            return {
                metric: me.metric,
                dashboardModel: me.dashboardModel,
                postTagsById: me.postTagsById
            };
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            const showPostTags = me.getProp('showPostTags');

            RivalIQ.postTags.utils.updateBodyClass(undefined, showPostTags);
        },

        getBaseMetric: function () {
            const me = this;

            const metricAttrs = me.getProps();
            // The submetric for these metrics are configured to be the same string as the objectType.
            metricAttrs.property = metricAttrs.objectType;
            metricAttrs.orderBy = App.utils.getOrderBy(me);

            return App.utils.createInsightsMetric(metricAttrs.objectType, metricAttrs);
        },

        loadData: App.widgets.media.utils.wrapLoadDataForCustomDashboards(function () {
            const me = this;

            const definition = me.getBaseMetric();
            // add post tags stuff

            const metricsCollection = new RivalIQ.collections.MetricDefinitions([definition]);

            const fetches = [
                metricsCollection.fetch(),
                RivalIQ.postTags.data.PostTags.fetch()
            ];

            if (me.getProp('isInPostTagEditMode')) {
                const baseMetricConcept = me.getBaseMetric().concept;
                fetches.push(me.getPostTagCountsMetricDef(me.getProps()).fetch(), baseMetricConcept);
                fetches.push(me.getNumPostsCountsMetricDef(me.getProps()).fetch(), baseMetricConcept);
                fetches.push(RivalIQ.data.companyData.fetchPresences());
            }

            return $.when.apply($, fetches)
                .then(function (metric, postTags, postTagCounts, numPosts, companyData) {
                    metric = metric.first();
                    me.postTagsById = _.keyBy(postTags, 'id');
                    me.metric = metric;

                    const metricValues = metric.getValue({
                        format: false
                    });
                    let models = _.map(metricValues, function (value) {
                        const model = _.last(value);
                        model.id = _.head(value);
                        return model;
                    });

                    let orderBy = App.utils.getOrderBy(me);
                    const sortMetric = App.utils.createInsightsMetric(me.getProp('objectType'), {
                        property: orderBy,
                        source: me.getProp('source')
                    });
                    const sortFcn = new RivalIQ.models.MetricDefinition(sortMetric).getSortFunction();

                    if (orderBy === 'boosted_post_total_spend') {
                        orderBy = 'spend_amount';
                    }
                    models = models.sort(sortGridItem(me.getProp('sortOrder') || 1, orderBy, sortFcn));

                    // make sure we're not returning more models than we asked for (we may be using an almost identical cached result with a higher limit)
                    const trimmedModels = (metric.attributes.limit > -1) ? _.take(models, metric.attributes.limit) : models;

                    me.collection.reset(trimmedModels, {
                        silent: true
                    });
                    if (me.getProp('isInPostTagEditMode') && RivalIQ.postTags.utils.canShowPostTagManager()) {
                        me.dashboardModel.setTotalNumPosts(numPosts.getValue({
                            format: false
                        }));
                        me.dashboardModel.setPostTagCounts(postTagCounts.getValue({
                            format: false
                        }));
                        me.dashboardModel.setLoadedPosts(models);
                        me.dashboardModel.companyData = companyData;
                    }
                });
        }),

        emptyViewOptions: function () {
            const me = this;

            const elementName = (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post ? 'posts' : 'stories');

            return {
                elementName: elementName
            };
        },

        getEmptyView: function () {
            const me = this;
            const widget = (me.dashboardModel || me);

            let template = '#insightsStoriesGridNoStoriesTemplate';
            let getElementName = function (view) {
                return _.get(view, ['options', 'elementName']);
            };

            if (widget.getCuration().isCustomDashboard && me._no_load_attempted) {
                if (RivalIQ.props.channelRedacted(widget.getProps(), widget.getProp('source'))) {
                    template = '#insightsCustomDashboardsNoAccessTemplate';
                } else {
                    template = (widget.getProp('companyId') ? '#insightsCustomDashboardsNoFocusCompanyTemplate' : '#insightsCustomDashboardsNoLandscapeCompaniesTemplate');
                }

                getElementName = _.wrap(getElementName, function (fn, view) {
                    return s.capitalize(fn(view));
                });
            }

            return RivalIQ.views.ItemView.extend({
                className: 'grid-view-empty',
                template: template,
                templateHelpers: function () {
                    const me = this;
                    return {
                        elementName: getElementName(me),
                        sourceName: _.get(RivalIQ.enums.sourceDetails, [widget.getProp('source'), 'name'])
                    };
                }
            });
        },

        getExportColumnSize: _.constant(3)
    });
}, window.s);
